<dx-load-panel #loadPanel
  [(visible)]="loading"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="false"
  closeOnOutsideClick="false">
</dx-load-panel>

<div *ngIf="!loading">
  <dx-gallery *ngIf="hasPictures"
      #gallery
      id="gallery"
      [dataSource]="pictures"
      [width]="'100%'"
      [height]="'auto'"
      [loop]="true"
      [showNavButtons]="true"
      [showIndicator]="true"
  ></dx-gallery>

  <div class="preText padded-content" *ngIf="(course | async)?.subjectDescription">
    {{(course | async)?.subjectDescription}}
  </div>
  <div class="preText padded-content" *ngIf="(course | async)?.description">
    {{(course | async)?.description}}
  </div>
  <div class="wb-button-margin text-center">
    <app-button-with-login
      [text]="registerButtonText"
      type="success"
      [disabled]="disableRegisterButton"
      [returnUrl]="returnUrl"
      (onClick)="register($event)"
    ></app-button-with-login>
  </div>
</div>
